export default __webpack_public_path__ + "static/media/student-2.d4ef2596.jpg";